import { render, staticRenderFns } from "./BsGridToolbar.vue?vue&type=template&id=5f640dc1&"
import script from "./BsGridToolbar.vue?vue&type=script&lang=js&"
export * from "./BsGridToolbar.vue?vue&type=script&lang=js&"
import style0 from "./BsGridToolbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports